import { AUTH_PREFIX_PATH } from "configs/AppConfig";
import React from "react";
import { connect } from "react-redux";
import { Redirect, Route } from "react-router-dom";

const ProtectedRoute = ({
  lkLanguages,
  children,
  location,
  isAuthenticated,
  ...reset
}) => {
  return (
    <Route {...reset}>
      {isAuthenticated ? (
        children
      ) : (
        <Redirect
          to={{
            pathname: AUTH_PREFIX_PATH,
            state: { from: location },
          }}
        />
      )}
    </Route>
  );
};

const mapStateToProps = ({ lookup }) => {
  const { lkLanguages } = lookup;
  return { lkLanguages };
};
export default React.memo(connect(mapStateToProps)(ProtectedRoute));
